import { render, staticRenderFns } from "./SourceTable.vue?vue&type=template&id=799bc7a9&scoped=true"
import script from "./SourceTable.vue?vue&type=script&lang=ts"
export * from "./SourceTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799bc7a9",
  null
  
)

export default component.exports